// StagingBanner.js
import React from 'react';
import { HardHat } from 'lucide-react';
import { COLORS } from './theme';

// Mounted unconditionally in index.js (same "always-present sibling" pattern as
// UpdateAvailableBanner) so it shows up no matter which top-level view App.js happens to be
// rendering — login screen, loading state, or any dashboard shell. Renders nothing at all on the
// real production hostname; only ever visible on the permanent second Hosting site
// (cpp-field-service-app-staging.web.app — see PlatformOwnerConsole.js's STAGING_URL) used for
// in-progress work before it's pushed live. That site has a fixed, known hostname (unlike the
// preview channel it replaced 2026-08-24, which had a random per-creation hash suffix and needed
// a substring match instead), so this is a plain exact match now.
// Deliberately normal document flow, not position:fixed (unlike UpdateAvailableBanner's own
// bottom-floating toast) — this sits as a plain sibling ABOVE the app tree, so it pushes every
// dashboard shell's own header down by its own height instead of risking an overlap with
// whichever shell happens to also anchor something to the very top of the viewport.
export const isStagingHost = () => typeof window !== 'undefined' && window.location.hostname === 'cpp-field-service-app-staging.web.app';

function StagingBanner() {
  if (!isStagingHost()) return null;
  return (
    <div
      style={{
        backgroundColor: '#FFA500',
        color: COLORS.text,
        textAlign: 'center',
        // The first thing on the page on staging, so it is the element that meets the status bar
        // on an iPad or iPhone home-screen app: the orange extends up behind the clock and the text
        // starts below it. TechDashboard skips its own top inset on staging for this reason.
        padding: 'calc(6px + var(--safe-top, 0px)) 12px 6px 12px',
        fontSize: '12px',
        fontWeight: '700',
        letterSpacing: '0.01em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px'
      }}
    >
      <HardHat size={14} strokeWidth={2.25} />
      STAGING BUILD — in-progress work, not yet pushed live to real companies
    </div>
  );
}

export default StagingBanner;
